import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ffdf6a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-card lab-hero" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "lab-hero__body" }
const _hoisted_4 = { class: "lab-hero__title" }
const _hoisted_5 = { class: "lab-hero__tags" }
const _hoisted_6 = { class: "lp-tag lp-tag--purple" }
const _hoisted_7 = {
  key: 1,
  class: "lp-tag lp-tag--green"
}
const _hoisted_8 = {
  key: 2,
  class: "lp-tag lp-tag--grey"
}
const _hoisted_9 = {
  key: 0,
  class: "lab-hero__description"
}
const _hoisted_10 = {
  key: 1,
  class: "lab-hero__creator"
}
const _hoisted_11 = { class: "lab-hero__metrics" }
const _hoisted_12 = { class: "lab-hero__metric lab-hero__metric--xp" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "xp", -1))
const _hoisted_14 = { class: "lab-hero__metric" }
const _hoisted_15 = { class: "lab-hero__metric" }

import { computed } from 'vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import ItemKicker from './ItemKicker.vue';
import { useLearningPathI18n } from '../view/learningPath';
import { LEVEL_TONES, LabKind, labLevel, labTags } from './labs';
import type { INavEntry } from './usePathwayItemNav';


export default /*#__PURE__*/_defineComponent({
  props: {
    kind: null,
    resource: null,
    current: null
  },
  setup(__props: any) {

const props = __props as {
  kind: LabKind
  resource: any
  current: INavEntry | null
}



const { t, lang, tl } = useLearningPathI18n();

const level = computed(() => labLevel(props.resource));
const tags = computed(() => labTags(props.resource));
const percentage = computed(() => Number(props.resource.percentage) || 0);
const totalFlags = computed(() => Number(props.resource.total_flags) || 0);
const flagsDone = computed(() => Math.round((percentage.value / 100) * totalFlags.value));
const xp = computed(() => props.kind === 'challenge' ? props.resource.points : props.resource.xp);
const osName = computed(() => {
  const os = String(props.resource.os_name || '').toLowerCase();
  return ({ linux: 'Linux', windows: 'Windows', osx: 'macOS', android: 'Android', androiud: 'Android' } as Record<string, string>)[os] || null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["lab-hero__media", { 'lab-hero__media--photo': __props.kind === 'machine' && __props.resource.photo_path }])
    }, [
      (__props.kind === 'machine' && __props.resource.photo_path)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.resource.photo_path,
            alt: __props.resource.name
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createBlock(HcIcon, {
            key: 1,
            name: __props.kind === 'machine' ? 'display' : 'terminal',
            size: 40
          }, null, 8, ["name"]))
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ItemKicker, {
        kind: __props.kind,
        current: __props.current
      }, null, 8, ["kind", "current"]),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(__props.resource.name), 1),
      _createElementVNode("div", _hoisted_5, [
        (_unref(level))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["lp-tag", `lp-tag--${_unref(LEVEL_TONES)[_unref(level)]}`])
            }, _toDisplayString(_unref(t)(`${_unref(lang)}.common.${_unref(level)}`)), 3))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(tl)('training')), 1),
        (__props.resource.is_freemium)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)(`${_unref(lang)}.user_progress.free`)), 1))
          : _createCommentVNode("", true),
        (_unref(osName))
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _createVNode(HcIcon, {
                name: "cpu",
                size: 13
              }),
              _createTextVNode(_toDisplayString(_unref(osName)), 1)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), (tag) => {
          return (_openBlock(), _createElementBlock("span", {
            key: tag,
            class: "lp-tag lp-tag--grey"
          }, _toDisplayString(tag), 1))
        }), 128))
      ]),
      (__props.resource.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.resource.description), 1))
        : _createCommentVNode("", true),
      (__props.kind === 'machine' && __props.resource.creator)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
            _createTextVNode(_toDisplayString(_unref(t)(`${_unref(lang)}.common.creator`)) + ": ", 1),
            _createElementVNode("strong", null, _toDisplayString(__props.resource.creator.nick || 'No nick'), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", null, [
            _createVNode(HcIcon, {
              name: "gem",
              size: 14
            }),
            _createTextVNode(_toDisplayString(_unref(tl)('reward')), 1)
          ]),
          _createElementVNode("strong", null, [
            _createTextVNode(_toDisplayString(_unref(xp) ?? 0), 1),
            _hoisted_13
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", null, [
            _createVNode(HcIcon, {
              name: "flag",
              size: 14
            }),
            _createTextVNode(_toDisplayString(_unref(tl)('flags')), 1)
          ]),
          _createElementVNode("strong", null, _toDisplayString(_unref(flagsDone)) + "/" + _toDisplayString(_unref(totalFlags)), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", null, [
            _createVNode(HcIcon, {
              name: "check",
              size: 14
            }),
            _createTextVNode(_toDisplayString(_unref(tl)('your_progress')), 1)
          ]),
          _createElementVNode("strong", null, _toDisplayString(_unref(percentage)) + "%", 1)
        ])
      ])
    ])
  ]))
}
}

})